import { useCallback, useContext } from "react";
import { findIndex, keyBy, maxBy, sortBy } from "lodash";

import { swap } from "utils";

import { ScreenContext } from "..";

export function useScreenManager() {
  const { store, dispatch } = useContext(ScreenContext);

  const front = useCallback(() => {
    return maxBy(Object.values(store.zMap), "z")?.screen;
  }, [store.zMap]);

  const promote = useCallback(
    (screen) => {
      if (!(screen in store.zMap)) return;

      const zList = sortBy(Object.values(store.zMap), "z");
      const newOrder = swap(
        zList,
        findIndex(zList, { screen }),
        zList.length - 1
      ).map(({ z, ...props }, i) => {
        return { ...props, z: i + 1 };
      });

      dispatch({
        type: "set-z-index",
        value: keyBy(newOrder, "screen"),
      });
    },
    [store.zMap, dispatch]
  );

  return { front, promote };
}

export default useScreenManager;
